import { render, staticRenderFns } from "./PrizesThumb.vue?vue&type=template&id=2a0cbca2&scoped=true"
import script from "./PrizesThumb.vue?vue&type=script&lang=js"
export * from "./PrizesThumb.vue?vue&type=script&lang=js"
import style0 from "./PrizesThumb.vue?vue&type=style&index=0&id=2a0cbca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0cbca2",
  null
  
)

export default component.exports